// extracted by mini-css-extract-plugin
export default {"character":"Character_character__pUz4w","table":"Character_table__klu2m","feature":"Character_feature__AMTPz"};